import React from "react";
import ReactDOM from "react-dom";

export interface ConfirmationDialogProps {
  visible: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isDangerous?: boolean;
  cancelIsPrimary?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  visible,
  title,
  message,
  confirmText,
  cancelText,
  isDangerous,
  cancelIsPrimary,
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 100001,
        backdropFilter: "blur(4px)",
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: "var(--bg-primary)",
          border: "1px solid var(--border)",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: "0 0 12px 0", fontSize: "18px" }}>{title}</h3>
        <p
          style={{
            margin: "0 0 24px 0",
            color: "var(--text-secondary)",
            lineHeight: "1.5",
          }}
        >
          {message}
        </p>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: cancelIsPrimary
                ? "var(--accent)"
                : "var(--bg-subtle)",
              border: cancelIsPrimary ? "none" : "1px solid var(--border)",
              borderRadius: "6px",
              color: cancelIsPrimary
                ? "var(--text-on-accent)"
                : "var(--text-primary)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              if (cancelIsPrimary) {
                e.currentTarget.style.opacity = "0.9";
              } else {
                e.currentTarget.style.background = "var(--bg-hover)";
              }
            }}
            onMouseLeave={(e) => {
              if (cancelIsPrimary) {
                e.currentTarget.style.opacity = "1";
              } else {
                e.currentTarget.style.background = "var(--bg-subtle)";
              }
            }}
          >
            {cancelText || "Cancel"}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "8px 16px",
              background: isDangerous ? "var(--danger)" : "var(--accent)",
              border: "none",
              borderRadius: "6px",
              color: "var(--text-on-accent)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "0.9";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
          >
            {confirmText || "Confirm"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
